import { AxiosRequestConfig } from "axios";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import { Report } from "src/Interfaces/TableInterfaces";
import {
  MarketHistoryCategory,
  MarketHistoryRow,
  MarketHistorySearchParams,
  MarketHistoryOverview,
} from "src/Interfaces/marketHistory";
import { getRequest, getTable, postRequest, postDownloadExcel } from "./requestTemplates";

export const getMarketHistoryExcel = (category: MarketHistoryCategory, search: MarketHistorySearchParams) =>
  postDownloadExcel(`/v1/markethistory/${category}/excel`, search);

export const getMarketHistoryChart = (
  category: MarketHistoryCategory,
  search: MarketHistorySearchParams,
  signal?: AbortSignal,
): Promise<Graph_Dto[]> =>
  postRequest(`/v1/markethistory/${category}/chart`, search, { signal });

export const getMarketHistoryOverview = (
  category: MarketHistoryCategory,
  search: MarketHistorySearchParams,
  signal?: AbortSignal,
): Promise<MarketHistoryOverview | null> =>
  postRequest(`/v1/markethistory/${category}/overview`, search, { signal });

export const getMarketHistoryOptions = (
  category: MarketHistoryCategory,
  signal?: AbortSignal,
): Promise<DropdownItem[]> =>
  getRequest(`/v1/markethistory/${category}/dropdown`, { signal });

export const getMarketHistoryTable = (
  category: MarketHistoryCategory,
  search: MarketHistorySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<MarketHistoryRow>> =>
  getTable(
    `/v1/markethistory/${category}/table`,
    search,
    offset,
    pageSize,
    sortingType,
    undefined,
    axiosOptions,
  );
